export default {
  loggedIn: (state) => !!state.currentUser,
  currentUser: (state) => state.currentUser,
  userInitials: (state) => state.currentUser.given_name.charAt(0)
    + state.currentUser.family_name.charAt(0),
  userRoles: (state) => state.currentUser.roles || [],
  isLoading: (state) => state.loading,
};
